import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'app-business-capital-en-v2',
    templateUrl: './business-capital-en-v2.component.html',
    styleUrls: ['./business-capital-en-v2.component.css'],
    standalone: false
})
export class BusinessCapitalEnV2Component implements OnInit, OnChanges {
  @Input() printActive: boolean
  @Input() returnData: any
  @Input() isSinglePageReturn: boolean
  directorScheduling = [];
  capitalPartnershipFirm = [];
  businessCapitalExceptDirector = [];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.directorScheduling = [];
    this.capitalPartnershipFirm = [];
    this.businessCapitalExceptDirector = [];

    this.returnData?.headSummery?.assetsAndLiabilities?.forEach(item=>{
      if(item.secondSubTypeKey === 'director_shareholdings_in_limited_companies'){
        this.directorScheduling = this.directorScheduling.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'capital_of_partnership_firm'){
        this.capitalPartnershipFirm = this.capitalPartnershipFirm.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'business_capital_other_than_directors_shareholdings_in_limited_companies'){
        this.businessCapitalExceptDirector = this.businessCapitalExceptDirector.concat(item.detailsOfAL)
      }
    })
  }

}
